<div class="d-flex flex-column spacing-8 flex-grow-1 trend-widget">
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex flex-column" style="width: 100%">
      <h3 class="h4-reg primary-60">{{ title }}</h3>
      <div class="h2-subheaders primary-100">{{ formattedValue || '&nbsp;' }}</div>
    </div>
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions()"
      style="width: 50%; height: 55px; display: block"></highcharts-chart>
  </div>
  <div class="d-flex spacing-16 align-items-center">
    <app-badges
      [Type]="changeType"
      [IconType]="iconType"
      label="{{ isNaN(changeValue!) ? 'NaN' : changeValue + '%' }}"></app-badges>
    <div>
      <h3 class="h3-bold primary-100">{{ comparePeriodLabel }}</h3>
    </div>
  </div>
</div>
